import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import styles from "./webfile.module.scss"
import Waveform from "../../../media-output/audiowave"
import classNames from "classnames"
import DirectLink from "../../direct-link/direct-link"
import axios from "axios"

const Webfile = ({ item, type, viewMedia }) => {

  const [innerContent, setInnerContent] = useState("")

  const shouldDisplayPlaceholder = ignorePending => {
    let ref = item && item.sourceFile ? item.sourceFile : item
    return (
      ref.webViewStatus &&
      ((ref.webViewStatus === "PENDING" && !ignorePending) ||
        ref.webViewStatus === "EMPTY")
    )
  }

  const displayArchive = () => {
    return (
      <div
        className={classNames(
          styles?.webfileIconFile,
          styles?.icons,
          "webfile-icon-file"
        )}
      ></div>
    )
  }
  const displayAudio = () => {
    if (shouldDisplayPlaceholder()) {
      return (
        <Waveform data={item} webfile={true} />
      )
    } else {
      return (
        <div className={styles?.audioWrapper}>
          <audio controls autoplay>
            <source src={item.webViewUrl} />
            Your browser does not support the audio tag.
          </audio>
        </div>
      )
    }
  }

  console.log("item", item)
  const displayDocument = () => {
    if (shouldDisplayPlaceholder(true)) {
      return (
        <div
          // id={item.id + "_document"}
          className={classNames(styles?.webfileIconPdf, styles?.icons, "webfile-icon-pdf")}
        >
        </div>
      );
    } else {
      console.log("Pdf details:", item)
      let url = ''
      if (viewMedia) {
        url = axios.defaults.baseURL + "/media/preview/" + item.sourceFile.id
      }  
      console.log("Url:", url)
      console.log("Item:", item)
      return (
        // <img
        //   id={item.id + "_document"}
        //   className={styles?.photoWrapper}
        //   src={item.webViewUrl}
        // />        
        <div style={{ height: 'inherit' }}>
          <div style={{ height: 'inherit' }}>
            <img
              id={item.id + "_document"}
              className={styles?.photoWrapper}
              src={item.webViewUrl}
            />
          </div>
          {viewMedia ? <DirectLink
            linkTo={`${url}`}
            showArrow={true}
          />
          : ''}
        </div>
      );
    }
  };


  const [aspectRatio, setAspectRatio] = useState(null);

  // Calculate the aspect ratio of the image
  const getAspectRatio = (url) => {
    const img = new Image();
    img.onload = () => {
      const ratio = img.width / img.height;
      setAspectRatio(ratio);
    };
    img.src = url;
  };

  useEffect(() => {
    if (item && item.webViewUrl) {
      getAspectRatio(item.webViewUrl);
    }
  }, [item]);

  const getImageStyle = () => {
    // Return different styles depending on aspect ratio
    if (aspectRatio === null) return {}; // If we haven't loaded the image yet, don't apply any styles
    return aspectRatio > 1
      ? { width: "100%", height: "auto" } // Landscape
      : { height: "100%", width: "auto" }; // Portrait
  };
  const displayPhoto = () => {
    // TODO this is always pending on upload even though it seems to be available? "true" can be false if this was working
    if (shouldDisplayPlaceholder(true)) {
      return (
        <div
          className={classNames(
            styles?.webfileIconPhoto,
            styles?.icons,
            "webfile-icon-photo",
          )}
        ></div>
      )
    } else {
      return (
        <img
          id={item.id + "_photo"}
          className={styles?.photoWrapper}
          src={item.webViewUrl}
          // style={getImageStyle()} // Apply dynamic styles based on aspect ratio
          // onClick={() => {
          //   console.log("clicked");
          //   const linkTo = `${item.webViewUrl}`;
          //   window.open(linkTo, "_blank")
          // }}
        />
      )
    }
  }
  const displayVideo = () => {
    if (shouldDisplayPlaceholder(true)) {
      return (
        <div
          className={classNames(
            styles?.webfileIconVideo,
            styles?.icons,
            "webfile-icon-video"
          )}
        ></div>
      )
    } else {
      return <img className={styles?.videoWrapper} src={item.webViewUrl} />

      // TODO we could return this instead if we get the icons working and the filetype is mp4
      // <Player
      //   className={styles?.wrapper}
      //   src={item.source_file.url}
      //   playsInline
      //   poster={item.webview_file ? item.webview_file.url : ""}
      // ></Player>
    }
  }

  // displayStory probably doesn't get used anywhere...
  const displayStory = () => {
    return <div className={styles?.storyWrapper}></div>
  }

  useEffect(() => {
    switch (type) {
      case "Archive":
        setInnerContent(displayArchive())
        break
      case "Audio":
        setInnerContent(displayAudio())
        break
      case "Document":
        setInnerContent(displayDocument())
        break
      case "Photo":
        setInnerContent(displayPhoto())
        break
      case "Video":
        setInnerContent(displayVideo())
        break
      case "Story":
        setInnerContent(displayStory())
        break
      default:
        setInnerContent(<div>Unknown File Type</div>)
    }
  }, [type, item])

  return <div className={styles?.wrapper}>{innerContent}</div>
}

Webfile.defaultProps = {}

Webfile.propTypes = {
  item: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
}

export default Webfile
